import { Component } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { PlacePickerComponent } from "src/app/place-picker/place-picker.component";
import { ApiService } from "src/app/shared/services/api.service";
import { ToastrMsgService } from "src/app/shared/services/shared-services/toastr.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-org-organization",
  templateUrl: "./org-organization.component.html",
  styleUrl: "./org-organization.component.css",
})
export class OrgOrganizationComponent {
  orgForm!: FormGroup;
  Branch!: FormGroup;
  material!: FormGroup;
  machine!: FormGroup;
   form!: FormGroup;
   /** Super Admin only: edit the active subscription of the org being viewed. */
   subscriptionForm!: FormGroup;
   subscriptionList: any[] = [];
   activeSubscription: any = null;
   isSuperAdmin = false;
   loadingSubscription = false;
   savingSubscription = false;
  /** Same four domains as `domain-selection` / purchase flow (order matches UX). */
  readonly subscriptionDomainCatalog = [
    { name: "Consultancy" as const },
    { name: "Road" as const },
    { name: "Construction" as const },
    { name: "Utilities" as const },
  ];
  /** Domains currently included on the subscription row (non-null JSON columns). */
  selectedSubscriptionDomains: string[] = [];
  /** Rolled-up caps shown next to per-domain inputs (matches top-level DB fields). */
  subscriptionTotalUsers = 0;
  subscriptionTotalProjects: number | null = null;
  submitted = false;
 orgEmp=false
  organizationId: any;
  states: any;
  cities: any;
  roleName: any;
  domainOptions: any = [];
  isBranch = false;
  domanArray: any;
  selectedFile: File | null = null;
  imagePreview: string | null = null;
  orgname: any;
  orgCode: any;
  orgType: any;
  imageBaseUrl = environment.imageBaseUrl;
  organizations: { id: any; value: any }[] = [
  { id: 1, value: 'Principal/PMO' },
  // { id: 2, value: 'SaaS Product Owner' },
  { id: 3, value: 'Contractor/Subcontractor' },
  { id: 4, value: 'Other' }
];
  organizationDesignations: { [key: string]: string[] } = {
  1: [
    'Project Manager',
    'Assistant Project Manager',
    'Planner',
    'Lead Civil Engineer',
    'Site Engineer',
    'Geotechnical Engineer',
    'Surveyor',
    'Construction Manager',
    'Foreman',
    'Supervisor',
    'Safety Officer',
    'Financial Controller',
    'Purchasing Manager',
    'Stores Incharge',
    'Sales Manager',
    'Business Development Officer',
    'HR Manager',
    'Accountant',
    'Cost Analyst'
  ],

  2: [
    'SaaS Product Owner',
    'Sales Manager',
    'Support Analyst',
    'Financial Analyst',
    'Developer',
    'Business Development Officer'
  ],

  3: [
 
    ' Project Manager',
    'Planner',
    'Asphalt Contractor',
    'Concrete Contractor',
    'Surveyor',
    'Supervisor',
    'Worker',
    'Mason',
    'Helper',
    'Equipment Manager',
    'Driver',
    ' Purchasing Agent',
    ' Stores Incharge',
    ' Sales Representative',
    ' Accountant',
    'Payroll Specialist',
    ' Site Supervisor',
    ' Worker',
    ' Mason',
    ' Helper',
    ' Surveyor',
    ' Equipment Operator',
    ' Logistics Coordinator',
    ' Accountant',
    ' Billing Clerk'
  ],

  4: [
    'Community Liaison Officer',
    'Regulatory Financial Auditor',
    'Government Inspector',
    'Environmental Consultant'
  ]
};
designationList: string[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private readonly apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private readonly toastrMsgService: ToastrMsgService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    // Session shape is best-effort: the user blob can be missing during
    // edit flows opened from a deep link, and `domain` may be absent
    // entirely on legacy accounts. Degrade gracefully instead of crashing.
    const rawUser = localStorage.getItem("user");
    const userParse = rawUser ? JSON.parse(rawUser) : null;
    this.roleName = userParse?.user?.role_name ?? "";

    const u = userParse?.user || {};
    this.isSuperAdmin =
      u?.type === 1 ||
      u?.role_id === 1 ||
      u?.role_name === "Admin" ||
      u?.role_name === "Super Admin";

    const rawDomain = userParse?.user?.domain;
    if (Array.isArray(rawDomain)) {
      this.domainOptions = rawDomain.map((d: any) => (d ?? "").toString().trim()).filter(Boolean);
    } else if (typeof rawDomain === "string" && rawDomain.length > 0) {
      this.domainOptions = rawDomain.split(",").map((d) => d.trim()).filter(Boolean);
    } else {
      this.domainOptions = [];
    }

    this.route.params.subscribe((params) => {
      this.organizationId = params["id"];
    });
    if (this.organizationId) {
      this.getOrganizationDetails();
      if (this.isSuperAdmin) {
        this.loadSubscription();
      }
    }

    const domainCapGroup = () =>
      this.formBuilder.group({
        users_count: [0, [Validators.min(0)]],
        projects_count: [null as number | null],
      });
    this.subscriptionForm = this.formBuilder.group({
      id: [null],
      subscription_user_type: ["trial_user"],
      duration: [1, [Validators.min(1)]],
      total_amount: [0, [Validators.min(0)]],
      membership_start_date: [""],
      membership_end_date: [""],
      status: ["active"],
      payment_status: [0],
      /** Shown in audit / merged into subscription metadata on save. */
      update_reason: [""],
      Road: domainCapGroup(),
      Construction: domainCapGroup(),
      Utilities: domainCapGroup(),
      Consultancy: domainCapGroup(),
    });
    this.subscriptionDomainCatalog.forEach((d) => {
      this.subscriptionForm
        .get(d.name)
        ?.valueChanges.subscribe(() => this.recomputeSubscriptionTotals());
    });
    this.orgForm = this.formBuilder.group({
      org_id: [this.organizationId],
      org_name: ["", Validators.required],
      org_type: ["", Validators.required],
      registration_number: [""],
      gst_number: [
        "",
        [
          Validators.required,
          Validators.pattern(
            "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
          ),
        ],
      ],
      pan_number: [
        "",
        [Validators.required, Validators.pattern("^[A-Z]{5}[0-9]{4}[A-Z]{1}$")],
      ],
      city: ["", Validators.required],
      state: ["", Validators.required],
      postal_code: ["", Validators.required],
      country: ["", Validators.required],
      domain: ["", Validators.required],
      org_logo: [null],
      address_line_1: ["", Validators.required],
      address_line_2: ["", Validators.required],
      additional_branch: [false],
      company_code: [""],
      primary_contact_name: [""],
      primary_contact_phone: [""],
      primary_contact_email: [""],
    });

    this.form = this.formBuilder.group({
      branch_id: [+this.organizationId, Validators.required],
      full_name: ['', Validators.required],
      specialization: [''],
      contact_email: ['', [Validators.required, Validators.email]],
      contact_phone: ['', Validators.required],
      department: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      postalCode: ['', Validators.required],
      isActive: [1],
      roleId: ['', Validators.required],
      domain: ['',],
      address: ['', Validators.required],
      emailId: ['', ],
      employeeNumber: ['', Validators.required],
      image: [''],
      emergencyContact: this.formBuilder.group({
        name: ['', Validators.required],
        mobile: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
        email: ['', [Validators.required, Validators.email]]
      }),
      employmentStartDate: ['', Validators.required],
      designation: ['', Validators.required],
      roleInSoftware: ['', Validators.required],
      membershipStartDate: [''],
      membershipEndDate: [''],
      employeeId: ['', [Validators.required]],
    });
  }

  finishWizard(): void {
    this.router.navigate(['/home/dashboard']);
  }

  /**
   * Super Admin only: fetch the org's subscriptions and patch the form with
   * the most-recent record so it can be edited in place.
   */
  loadSubscription(): void {
    if (!this.organizationId) return;
    this.loadingSubscription = true;
    this.apiService.getSubscriptionsList(this.organizationId).subscribe({
      next: (res: any) => {
        this.loadingSubscription = false;
        const list = Array.isArray(res) ? res : res?.data || [];
        this.subscriptionList = list;
        // The list is already sorted DESC by id on the server.
        this.activeSubscription = list[0] || null;
        if (this.activeSubscription) this.patchSubscriptionForm(this.activeSubscription);
      },
      error: (err) => {
        this.loadingSubscription = false;
        console.error('Failed to load subscriptions:', err);
        this.toastrMsgService.error(err?.error?.message || 'Failed to load subscriptions');
      },
    });
  }

  /** DB column name for each UI domain key (same mapping as create-subscription). */
  private readonly subscriptionDbKey: Record<string, string> = {
    Road: "road",
    Construction: "construction",
    Utilities: "utilities",
    Consultancy: "consultancy",
  };

  private patchSubscriptionForm(sub: any): void {
    this.subscriptionForm.patchValue(
      {
        id: sub.id,
        subscription_user_type: sub.subscription_user_type || "trial_user",
        duration: sub.duration ?? 1,
        total_amount: sub.total_amount ?? 0,
        membership_start_date: sub.membership_start_date
          ? new Date(sub.membership_start_date)
          : "",
        membership_end_date: sub.membership_end_date
          ? new Date(sub.membership_end_date)
          : "",
        status: sub.status || "active",
        payment_status: sub.payment_status ?? 0,
        update_reason: "",
      },
      { emitEvent: false }
    );

    const selected: string[] = [];
    for (const { name } of this.subscriptionDomainCatalog) {
      const dbKey = this.subscriptionDbKey[name];
      const cell = sub[dbKey];
      if (cell != null && cell !== "") {
        selected.push(name);
        const parsed =
          typeof cell === "string" ? this.safeJsonParse(cell) : cell;
        this.subscriptionForm.get(name)?.patchValue(
          {
            users_count: Number(parsed?.users_count) || 0,
            projects_count:
              parsed?.projects_count != null &&
              parsed?.projects_count !== ""
                ? Number(parsed.projects_count)
                : null,
          },
          { emitEvent: false }
        );
      } else {
        this.subscriptionForm
          .get(name)
          ?.patchValue({ users_count: 0, projects_count: null }, { emitEvent: false });
      }
    }

    // Legacy row: only top-level caps, no per-domain JSON — mirror org domains or Consultancy.
    if (selected.length === 0) {
      const topUsers =
        Number(sub.users_count) || this.deriveUsersCountFromDomains(sub) || 1;
      const topProjects =
        sub.consultancy_projects != null && sub.consultancy_projects !== ""
          ? Number(sub.consultancy_projects)
          : null;
      const orgDomains = Array.isArray(this.domanArray) ? this.domanArray : [];
      const prefer = ["Consultancy", "Road", "Construction", "Utilities"].find(
        (d) => orgDomains.includes(d)
      );
      const pick = prefer || "Consultancy";
      selected.push(pick);
      this.subscriptionForm.get(pick)?.patchValue(
        {
          users_count: topUsers,
          projects_count: topProjects,
        },
        { emitEvent: false }
      );
    } else if (
      selected.includes("Consultancy") &&
      (sub.consultancy_projects != null && sub.consultancy_projects !== "")
    ) {
      const cur = this.subscriptionForm.get("Consultancy")?.value;
      if (cur?.projects_count == null || cur?.projects_count === "") {
        this.subscriptionForm.get("Consultancy")?.patchValue(
          { projects_count: Number(sub.consultancy_projects) },
          { emitEvent: false }
        );
      }
    }

    this.selectedSubscriptionDomains = [...selected];
    this.recomputeSubscriptionTotals();
  }

  toggleSubscriptionDomain(name: string): void {
    const i = this.selectedSubscriptionDomains.indexOf(name);
    if (i >= 0) {
      this.selectedSubscriptionDomains = this.selectedSubscriptionDomains.filter(
        (_, j) => j !== i
      );
    } else {
      this.selectedSubscriptionDomains = [
        ...this.selectedSubscriptionDomains,
        name,
      ];
      this.subscriptionForm
        .get(name)
        ?.patchValue({ users_count: 1, projects_count: null });
    }
    this.recomputeSubscriptionTotals();
  }

  isSubscriptionDomainSelected(name: string): boolean {
    return this.selectedSubscriptionDomains.includes(name);
  }

  recomputeSubscriptionTotals(): void {
    let users = 0;
    let projects = 0;
    let anyProject = false;
    for (const name of this.selectedSubscriptionDomains) {
      const v = this.subscriptionForm.get(name)?.value;
      users += Number(v?.users_count) || 0;
      const p = v?.projects_count;
      if (p !== null && p !== undefined && p !== "" && !isNaN(Number(p))) {
        anyProject = true;
        projects += Number(p);
      }
    }
    this.subscriptionTotalUsers = users;
    this.subscriptionTotalProjects = anyProject ? projects : null;
  }

  /** Sum users_count across the per-domain JSON columns (legacy shape). */
  private deriveUsersCountFromDomains(sub: any): number | null {
    const pick = (v: any): number => {
      if (!v) return 0;
      const parsed = typeof v === "string" ? this.safeJsonParse(v) : v;
      return Number(parsed?.users_count) || 0;
    };
    const total =
      pick(sub.road) +
      pick(sub.construction) +
      pick(sub.utilities) +
      pick(sub.consultancy);
    return total > 0 ? total : null;
  }

  private safeJsonParse(s: string): any {
    try {
      return JSON.parse(s);
    } catch {
      return null;
    }
  }

  /** Build `{ users_count, projects_count? }` or `null` for a domain column. */
  private buildDomainJson(uiName: string): object | null {
    if (!this.selectedSubscriptionDomains.includes(uiName)) return null;
    const v = this.subscriptionForm.get(uiName)?.value;
    const u = Math.max(0, Number(v?.users_count) || 0);
    const pRaw = v?.projects_count;
    const p =
      pRaw === null || pRaw === undefined || pRaw === ""
        ? null
        : Math.max(0, Number(pRaw));
    const o: Record<string, number> = { users_count: u };
    if (p !== null && !isNaN(p)) o["projects_count"] = p;
    return o;
  }

  /** Calendar YYYY-MM-DD in local time (avoids UTC off-by-one from toISOString). */
  private toLocalDateString(d: any): string | null {
    if (!d) return null;
    const dt = d instanceof Date ? d : new Date(d);
    if (isNaN(dt.getTime())) return null;
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  }

  /** Super Admin only: PATCH the active subscription with the form values. */
  saveSubscription(): void {
    if (!this.activeSubscription?.id) {
      this.toastrMsgService.warning(
        'No subscription exists for this organization yet.'
      );
      return;
    }
    if (this.selectedSubscriptionDomains.length === 0) {
      this.toastrMsgService.warning(
        "Select at least one domain (same as subscription purchase flow)."
      );
      return;
    }
    for (const name of this.selectedSubscriptionDomains) {
      const u = Number(this.subscriptionForm.get(name)?.get("users_count")?.value);
      if (!u || u < 1) {
        this.toastrMsgService.warning(
          `Each selected domain needs at least 1 user seat (${name}).`
        );
        return;
      }
    }
    if (this.subscriptionForm.invalid) {
      this.subscriptionForm.markAllAsTouched();
      this.toastrMsgService.warning('Please fix the highlighted subscription fields');
      return;
    }

    this.recomputeSubscriptionTotals();
    const raw = this.subscriptionForm.getRawValue();
    const reason =
      (raw.update_reason && String(raw.update_reason).trim()) ||
      "Updated by Super Admin via org edit";

    const payload: any = {
      subscription_user_type: raw.subscription_user_type,
      duration: Number(raw.duration) || null,
      total_amount: Number(raw.total_amount) || 0,
      users_count: this.subscriptionTotalUsers || null,
      consultancy_projects: this.subscriptionTotalProjects,
      membership_start_date: this.toLocalDateString(raw.membership_start_date),
      membership_end_date: this.toLocalDateString(raw.membership_end_date),
      status: raw.status,
      payment_status: Number(raw.payment_status) || 0,
      reason,
      road: this.buildDomainJson("Road"),
      construction: this.buildDomainJson("Construction"),
      utilities: this.buildDomainJson("Utilities"),
      consultancy: this.buildDomainJson("Consultancy"),
    };

    this.savingSubscription = true;
    this.apiService.updateSubscription(this.activeSubscription.id, payload).subscribe({
      next: (res: any) => {
        this.savingSubscription = false;
        this.activeSubscription = res?.data || this.activeSubscription;
        if (res?.data) this.patchSubscriptionForm(res.data);
        this.toastrMsgService.success('Subscription updated successfully');
      },
      error: (err) => {
        this.savingSubscription = false;
        const msg =
          err?.error?.message ||
          err?.error?.error ||
          'Failed to update subscription';
        this.toastrMsgService.error(msg);
      },
    });
  }

  getOrganizationDetails() {
    this.apiService.getOrganizations({} as any).subscribe({
      next: (res: any) => {
        const data = res.data.find(
          (project: any) => project.org_id == this.organizationId
        );
        if (data.additional_branch == "true") {
          this.isBranch = true;
        }
        if (typeof data.domain === "string") {
          this.domanArray = data.domain.split(",").map((s: string) => s.trim());
        } else {
          console.error("data is not a string:", data.domain);
        }

        this.orgForm.patchValue({
          org_name: data.org_name,
          org_type: data.org_type,
          registration_number: data.registration_number,
          gst_number: data.gst_number,
          pan_number: data.pan_number,
          country: data.country,
          state: data.state,
          city: data.city,
          postal_code: data.postal_code,
          domain: this.domanArray,
          org_logo: data.org_logo,
          address_line_1: data.address_line_1,
          address_line_2: data.address_line_2,
          company_code: data.company_code,
          additional_branch: data.additional_branch,
          primary_contact_name: data.primary_contact_name,
          primary_contact_phone: data.primary_contact_phone,
          primary_contact_email: data.primary_contact_email,
        });
        // this.onCountryChange();
        // this.onStateChange();
        this.orgname = data.org_name;
        this.orgCode = data.company_code;
        this.orgType = data.org_type;
        this.imagePreview = this.imageBaseUrl + data.org_logo;

        this.onCountryChange();
        this.onStateChange();
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => "",
    });
  }

  onCountryChange() {
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.states = res;
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => {
        // this.cities = [];
        if (this.organizationId) {
          this.orgForm.patchValue({
            state: this.orgForm.value.state,
            city: this.orgForm.value.city,
          });
        } else {
          this.orgForm.patchValue({ state: "", city: "" });
        }
      },
    });
  }

  onStateChange() {
    const state = this.orgForm.value.state;
    this.apiService.getdistricts(state).subscribe({
      next: (res) => {
        this.cities = res;
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => {
        if (this.organizationId) {
          this.orgForm.patchValue({ city: this.orgForm.value.city });
        } else {
          this.orgForm.patchValue({ city: "" });
        }
      },
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.uploadImage(this.selectedFile);
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  uploadImage(file: any) {
    if (file) {
      this.apiService.uploadContractDocs(file, "org")?.subscribe({
        next: (res: any) => {
          this.orgForm.patchValue({
            org_logo: res?.org,
          });

          this.orgForm.get("org_logo")?.updateValueAndValidity();
          this.toastrMsgService.success(
            "Organization logo uploaded successfully"
          );
        },
        error: (err) => console.error("Organization logo upload failed", err),
      });
    }
  }

  addOrg(type: any) {
    if (type == "Brnch") {
      this.isBranch = true;
    }
    const types = this.orgForm.value.domain;
    const result = types.join(", ");
    var addUser = {
      org_name: this.orgForm.value.org_name,
      org_type: this.orgForm.value.org_type,
      registration_number: this.orgForm.value.registration_number,
      gst_number: this.orgForm.value.gst_number,
      city: this.orgForm.value.city,
      state: this.orgForm.value.state,
      postal_code: this.orgForm.value.postal_code,
      pan_number: this.orgForm.value.pan_number,
      country: this.orgForm.value.country,
      address_line_2: this.orgForm.value.address_line_2,
      address_line_1: this.orgForm.value.address_line_1,
      domain: result,
      org_logo: this.orgForm.value.org_logo,
      additional_branch: this.orgForm.value.additional_branch,
      primary_contact_name: this.orgForm.value.primary_contact_name,
      primary_contact_phone: this.orgForm.value.primary_contact_phone,
      primary_contact_email: this.orgForm.value.primary_contact_email,
    };

    this.apiService.updateOrganization(this.organizationId, addUser).subscribe({
      next: (res: any) => {
        this.orgname = res.data.org_name;
        this.orgCode = res.data.company_code;
        this.orgType = res.data.org_type;

        this.toastrMsgService.success("Organization Updated successfully");
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => "",
    });
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
 onRoleChange(selectedOrg: string): void {
  console.log(selectedOrg)
    this.designationList = this.organizationDesignations[selectedOrg] || [];
  }
    onSubmit(): void {
    if (this.form.invalid) return;


    const formData = this.form.value;
 
      this.apiService.saveStaff(formData).subscribe({
        next: (res: any) => {
          // Check if payment is required
          if (res.requiresPayment) {
            const amount = res.amount || 0;
            const message = res.paymentPrompt || res.message || `Subscription limit exceeded. Please pay ₹${amount} to activate this staff member.`;
            
            // Show warning message
            this.toastrMsgService.warning(message);
            
            // Prompt admin to pay
            const confirmPayment = confirm(
              `${message}\n\nWould you like to proceed to payment now?`
            );
            
            if (confirmPayment && res.subscription) {
              // Navigate to payment/subscription page with subscription ID
              this.router.navigate(['/home/subscription'], {
                queryParams: {
                  subscriptionId: res.subscription.id,
                  amount: amount,
                  type: 'staff_payment'
                }
              });
            } else {
              // Staff created but inactive
              this.toastrMsgService.info('Staff member created but inactive. Please complete payment to activate.');
            }
          } else {
            this.toastrMsgService.success('Staff added successfully');
          }
        },
        error: (err) => {
          this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Save failed');
        }
      });

  }
  openEmp(){
    this.orgEmp=true
  }
  close(){
    this.orgEmp=false

  }

}
